import React, { useState } from "react";
import "./SapAbap.css";
import DownloadForm from "../DownloadForm/DownloadForm";

const SapFincon = () => {
  const [showForm, setShowForm] = useState(false);

  const handleDownloadClick = () => {
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
  };

  return (
    <div className="sapfincon-wrapper">
      {/* Animated Background Circles */}
      <div className="background-animation">
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
        <div className="floating-circle"></div>
      </div>

      {/* Header Section */}
      <div
        className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
        style={{ marginBottom: "90px" }}
      >
        <div className="container text-center py-5" style={{ marginTop: "-80px" }}>
          <h1 className="text-white display-1">SAP ABAP</h1>
          <div className="d-inline-flex text-white mb-5">
            <p className="m-0 text-uppercase">
              <a className="text-white" href="">Home</a>
            </p>
            <i className="fa fa-angle-double-right pt-1 px-3"></i>
            <p className="m-0 text-uppercase">SAP</p>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="sapfincon-flexbox">
        <div className="sapfincon-left">
          <div className="sapfincon-wrapper zoom-effect">
            <img
              src="/assets/img/sapfince.jpg"
              alt="SAP Banner"
              className="sapfincon-main-image"
            />
          </div>
        </div>
        <div className="sapfincon-right">
          <h2 className="sapfincon-title">Master SAP ABAP development and integration.</h2>
          <p className="sapfincon-description">
            SAP ABAP is the backbone of technical development in the SAP ecosystem, enabling businesses to customize and enhance SAP applications to meet specific business needs.
          </p>
          <ul className="sapfincon-list">
            {[
              "Build custom reports, interfaces, and forms using ABAP",
              "Develop enhancements and modifications to standard SAP programs",
              "Integrate SAP systems with external platforms via APIs",
              "Create database objects and perform complex data operations",
              "Work with modern tools like ABAP on HANA and Fiori",
              "Enable seamless module connectivity across SD, MM, FICO, and HCM",
            ].map((text, idx) => (
              <li className="sapfincon-list-item" key={idx}>
                <span className="sapfincon-icon">
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998
                       26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997
                       26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206
                       0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"/>
                  </svg>
                </span>
                <span className="sapfincon-text">{text}</span>
              </li>
            ))}
          </ul>
          <p className="sapfincon-careers">SAP ABAP Developer, Technical Consultant, Integration Expert</p>
        </div>
      </div>

      {/* Course Upgrade Section */}
       <div className="sapfincon-content-section">
        <div className="container">
          {/* Course Upgrade Section */}
          <div className="upgrade-section">
            <h2 className="section-title">
              <strong>Upgrade your coding skills with BDM Technology' Best-Selling SAP Finance and controlling Course!</strong>
            </h2>
            <p className="section-description">
              SAP FICO is the backbone of financial processing in organizations, helping businesses streamline accounting, financial reporting, and cost management.
            </p>
          </div>

          {/* Why Study */}
          <div className="why-study-section">
            <h3 className="subsection-title"><strong>Why Study SAP ABAP?</strong></h3>
            <p className="subsection-description">
              Learning SAP ABAP opens doors to the entire SAP ecosystem—from ECC to S/4HANA and Fiori. Whether you're automating processes or building enterprise logic, ABAP is the engine behind it all.
            </p>
          </div>

          {/* Benefits */}
          <div className="benefits-section">
            <h3 className="subsection-title"><strong>Benefits of Learning SAP ABAP</strong></h3>
            <ul className="benefits-list">
              <li><strong>Core SAP Development Skill</strong> – Build, extend, and enhance SAP applications.</li>
              <li><strong>In-Demand Expertise</strong> – Every SAP implementation needs skilled ABAP developers.</li>
              <li><strong>Custom Integration</strong> – Enable system-to-system communication via APIs and RFCs.</li>
              <li><strong>Cross-Module Utility</strong> – Supports FICO, MM, SD, HCM, and more.</li>
              <li><strong>Lucrative Technical Roles</strong> – High-paying job profiles in consulting and development.</li>
              <li><strong>Modernization Friendly</strong> – ABAP on HANA & UI5 expands your full-stack capabilities.</li>
            </ul>
          </div>

          {/* Future Scope */}
          <div className="future-scope-section">
            <h3 className="subsection-title"><strong>Future Scope of Learning SAP ABAP</strong></h3>
            <ul className="scope-list">
              <li><strong>S/4HANA Development</strong> – Leverage ABAP on HANA for next-gen solutions.</li>
              <li><strong>Fiori & UI5 Integration</strong> – Enable modern UIs and mobile-friendly applications.</li>
              <li><strong>REST & OData API Creation</strong> – Build scalable web services for SAP.</li>
              <li><strong>Continuous Innovation</strong> – Evolving with SAP’s cloud-first strategy.</li>
              <li><strong>Global Enterprise Demand</strong> – Needed in all SAP-driven industries.</li>
            </ul>
          </div>

          {/* Key Features Section */}
          <div className="key-features-section">
            <h3 className="subsection-title">
              <strong>Key Features of BDM Technology</strong>
            </h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>100% Job-Oriented Training</h4>
                <p>Curriculum tailored to industry requirements, ensuring you gain the skills employers are looking for.</p>
              </div>
              <div className="feature-item">
                <h4>Industry Expert Faculties</h4>
                <p>Learn from seasoned professionals with real-world experience.</p>
              </div>
              <div className="feature-item">
                <h4>Flexible Demo Class Available</h4>
                <p>Opportunity to attend a demo session and experience the training style before enrolling.</p>
              </div>
              <div className="feature-item">
                <h4>Completed 400+ Batches</h4>
                <p>Proven track record with hundreds of successful batches, demonstrating program reliability and effectiveness.</p>
              </div>
              <div className="feature-item">
                <h4>Certification Guidance</h4>
                <p>Support throughout your journey to help you earn relevant certifications that boost your career.</p>
              </div>
              <div className="feature-item">
                <h4>Live Practical Sessions</h4>
                <p>Hands-on, interactive sessions to reinforce learning and apply concepts in real-time.</p>
              </div>
              <div className="feature-item">
                <h4>Peaceful Environment</h4>
                <p>A conducive learning atmosphere that helps you focus and maximize your learning potential.</p>
              </div>
            </div>
          </div>

          {/* Who Should Attend Section */}
        
          {/* Who Should Attend */}
          <div className="who-attend-section">
            <h3 className="subsection-title"><strong>Who Should Enroll</strong></h3>
            <ul className="attend-list">
              <li>Graduates in Computer Science, IT, or Engineering</li>
              <li>Software Developers looking to enter SAP ecosystem</li>
              <li>Functional Consultants aiming to enhance technical skills</li>
            </ul>
          </div>


          {/* Hiring Companies Section */}
         <div className="hiring-companies-section">
  <h3 className="subsection-title">
    <strong>Hiring Companies</strong>
  </h3>
  <div className="companies-grid">
    {[
      { logo: "/assets/img/Cognizant.png" },
      {  logo: "/assets/img/tcs.jpg" },
      {  logo: "/assets/img/infoysis.jpg" },
      { logo: "/assets/img/ibm.png" },
      {  logo: "/assets/img/hcl.png" },
      {  logo: "/assets/img/Accenture.png" },
      { logo: "/assets/img/capgemini.png" },
      {  logo: "/assets/img/Deloitte.png" },
      {  logo: "/assets/img/nttdata.png" },
      { logo: "/assets/img/wipro.png" },
      { logo: "/assets/img/KaarTech.png" },
      {  logo: "/assets/img/lt.png" },
      {  logo: "/assets/img/Siemens.png" },
      {  logo: "/assets/img/techmahindra.png" },
    ].map((company, index) => (
      <div className="company-card" key={index}>
        <img
          src={company.logo}
          alt={company.name}
          className="company-logo"
        />
        <span className="company-name">{company.name}</span>
      </div>
    ))}
  </div>
</div>


          {/* Salary Overview Section */}
          <div className="salary-overview-section">
            <h3 className="subsection-title">
              <strong>Salary Overview</strong>
            </h3>
            <div className="salary-grid">
              <div className="salary-item">
                <h4>Entry-Level (0-2 Years)</h4>
                <p className="salary-amount">₹5 - 8 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Mid-Level (2-5 Years)</h4>
                <p className="salary-amount">₹8 - 14 LPA</p>
              </div>
              <div className="salary-item">
                <h4>Senior-Level (5+ Years)</h4>
                <p className="salary-amount">₹14 - 22+ LPA</p>
              </div>
              <div className="salary-item">
                <h4>Solution Architects & Finance Leads</h4>
                <p className="salary-amount">₹25 - 35 LPA</p>
                
              </div>
            </div>
             
          </div>
         <div className="download-section">
            <h3 className="download-heading">
              Want to know more? <br />
              <span>Please download the course PDF.</span>
            </h3>
            <button className="download-button" onClick={handleDownloadClick}>
              📄 Download Course PDF
            </button>
          </div>

          {showForm && (
        <DownloadForm
          onClose={handleCloseForm}
          courseName="SAP ABAP"
          pdfUrl="/uploads/pdfs/05.pdf" // 🔁 replace with your actual PDF path
        />
      )}

        </div>
      </div>

     
    </div>
  );
};

export default SapFincon;